import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type {
  IAdminSettingsPaymentCountryGroupListItem,
} from '../types';
import {
  SETTINGS_PAYMENT_COUNTRY_GROUPS_LIST_QUERY_KEY,
  SETTINGS_PAYMENT_COUNTRY_GROUPS_LIST_URL,
} from '../constants';

export default function useSettingsPaymentCountryGroupsListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IAdminSettingsPaymentCountryGroupListItem>, Error> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAdminSettingsPaymentCountryGroupListItem>>({
    queryKey: [SETTINGS_PAYMENT_COUNTRY_GROUPS_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAdminSettingsPaymentCountryGroupListItem>>(
      SETTINGS_PAYMENT_COUNTRY_GROUPS_LIST_URL,
      tableState.value,
      {
        signal,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
